<template>
  <base-section id="brief-offer">
    <base-section-heading :title="$t('sections.briefOffer.header')">
      {{ $t("sections.briefOffer.description") }}
    </base-section-heading>

    <v-overlay opacity="0.85" :dark="false" :value="overlay">
      <div class="overlay-full" @click="closeOverlay()"></div>
      <div class="overlay-content">
        <div id="body">
          <v-card
            elevation="24"
            :dark="false"
            class="card"
            v-if="selectedFeature"
          >
            <v-carousel
              :continuous="true"
              :cycle="true"
              :show-arrows="true"
              :hide-delimiters="true"
              show-arrows-on-hover
              hide-delimiter-background
              class="caruserl"
              height="100%"
            >
              <v-carousel-item
                v-for="(imgNumber, i) in selectedFeature.imagesNumbers || []"
                :key="i"
              >
                <v-img
                  height="100%"
                  :src="require(`@/assets/images/IMG_${imgNumber}.jpg`)"
                ></v-img>
              </v-carousel-item>
            </v-carousel>

            <div class="description" >
              <base-avatar-card
                  
                  v-bind="selectedFeature"
                  align="left"
                  horizontal
                  :color="null"
                  :dark="false"
                >
                </base-avatar-card>
                <a v-if="selectedFeature.url" :href="selectedFeature.url.href" target="_blank" >{{selectedFeature.url.name}}</a>
            </div>

  

          </v-card>
        </div>

        <v-btn icon @click="closeOverlay()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-overlay>

    <v-container>
      <v-row>
        <v-col
          class="feature-item"
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
          @click="selectFeature(feature)"
          @mouseover="hoverElement = i"
          @mouseleave="hoverElement = null"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
            :color="hoverElement == i ? 'primary' : null"
            :dark="hoverElement == i"
            :showButtonOnHover="true"
          >
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
import Translations from "@/services/Translations";
export default {
  name: "SectionThemeFeatures",
  mounted() {
    Translations.selsectedLanguage$.subscribe(
      () => this.features = Translations.getMessages().sections.briefOffer.offerList
    );
    this.openFeatureByUrl();
  },
  data: () => ({
    selectedFeature: null,
    hoverElement: null,
    overlay: false,
    features: [],
    colors: [
      "green",
      "secondary",
      "yellow darken-4",
      "red lighten-2",
      "orange darken-1",
    ],
    cycle: false,
    slides: ["First", "Second", "Third", "Fourth", "Fifth"],
  }),
  watch: {
    $route(to, from) {
      this.openFeatureByUrl();
    },
  },
  methods: {
    selectFeature(feature) {
      if (!feature) return;
      this.selectedFeature = feature;
      this.overlay = true;
    },
    closeOverlay() {
      this.overlay = false;
      this.selectedFeature = null;
    },
    openFeatureByUrl() {
      const section = this.$route.params.section;
      if (section) {
        const feature = this.features.find((v) => v.title == section);
        this.selectFeature(feature);
      }
    },
  },
};
</script>
<style lang="scss">
#brief-offer {
  .row > div {
    cursor: pointer !important;
  }

  .overlay-full,
  .v-overlay__content {
    height: 100%;
    width: 100%;
  }

  .overlay-content,
  .overlay-full {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .overlay-content {
    z-index: 100;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > .v-btn {
      color: white;
      margin: 25px 20px 0px;
      cursor: pointer;
    }

    > * {
      pointer-events: all;
    }
  }

.feature-item{
  min-height: 245px;
}


  #body {
    .card {
      @media all and (max-width: 1000px) {
        width: 95vw;
        height: 90vh;
      }
      width: 95vw;
      max-width: 1300px;
      height: 70vh;
      display: flex;

      .caruserl {
        flex: 65;

        .v-icon {
          font-size: 20px !important;
        }

        .v-img {
          height: 100%;
        }
      }

      .description {
        flex: 35;
        box-sizing: border-box;
        padding: 25px;
        margin-top: 30px;

        a{
          text-align: right;
          justify-self: flex-end;
          display: block;
        }

      }

      @media all and (max-width: 1000px) {
        flex-direction: column;

        .caruserl {
          flex: 60;
        }
        .description {
          flex: 45;
        }
      }
    }
  }
}
</style>
